import React from 'react';
import styled from 'styled-components';
import SearchTags from './Search/SearchTags';
import ChannelSearch from './Search/ChannelSearch';
import VideoSearch from './Search/VideoSearch';

const Search = (props) => {
    const { toggleTags, isChannelTags, setCurrentPage } = props
    return (
        <SearchWrap>
            <SearchTags isChannelTags={isChannelTags} toggleTags={toggleTags}/>
            {isChannelTags && <ChannelSearch setCurrentPage={setCurrentPage}/>}
            {!isChannelTags && <VideoSearch/>}
        </SearchWrap>
    )
}
export default Search;

const SearchWrap = styled.div`
    position: relative;
    width: 900px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);         
`


// WEBPACK FOOTER //
// ./src/InfoList/Search.js